import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Row, ContainerCol } from '../../componentes_generales/componentes_formulario/contenedores/';
import ModalResponsive from '../../componentes_generales/componentes_formulario/modals/modalresponsive';
import AgGridRender from '../../componentes_generales/grid/ag_grid_render';
import { InputText } from '../../componentes_generales/componentes_formulario/inputs/inputtext';

const ButtonModal = styled.button`
    height: 25px;
    line-height: 10px;
`;

const ModalContainer = styled.div`
    margin-top: 20px;
    height: 400px;
    width: 410px;
`;

const Hr = styled.hr`
    margin-top: 10px;
    margin-bottom: 10px;
`;

const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

class BusquedaProveedor extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            textBusqueda: '',
            isModalVisible: true,
            data: [],
            pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primeraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
            columnDefs: [
                {   header: "No.",
                    field: "NroItem",
                    width: 40,
                    type: "string",
                    suppressFilter: true
                },
                {   header: "Código",
                    field: "Codigo",
                    width: 100,
                    type: "string"
                },
                {   header: "Descripción",
                    field: "Descripcion",
                    width: 268,
                    type: "string"
                }
            ],
        }

        this.gridOptions = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: false,
            rowSelection: "single",
            paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            suppressRowClickSelection: false,
            onPaginationChanged: () => {
                if(!this.gridBusquedaApi){
                    return;
                }
                let totalFilas = this.gridBusquedaApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridBusquedaApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridBusquedaApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridBusquedaApi.paginationGetCurrentPage();
        
                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primeraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };
        
                this.setState({pagination});
            },
            onRowDoubleClicked: (event) => {
                this.onSelect();
            }
        }

        this.onGridReady = this.onGridReady.bind(this);
        this.setData = this.setData.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    onGridReady(params) {
        this.gridBusquedaApi = params.api;
        this.gridBusquedaColumnApi = params.columnApi;
    }

    handleInputChange(event){    
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });
    }

    setData(){
        let data = [];
        this.props.data.forEach((item,i) => {
            data.push({
                ...item,
                NroItem: (i+1)
            })
        });

        return data;
    }

    onSelect(){
        let row = this.gridBusquedaApi.getSelectedRows();
        this.props.onSelectedRow(row[0]);
    }

    /*filter(){
        let data = [];

        data = this.state.data.filter(item => {
            if( item.Codigo !== -1 || item.Descripcion !== -1 ){
                return item;
            }
        });
    }*/

    render(){
        return(
            <div>
                <ModalResponsive open={this.props.visible} onClose={this.props.onClose}>
                    <ModalContainer>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <h4>{this.props.title}</h4>
                                <Hr />
                            </ContainerCol>
                        </Row>

                        <Row>
                            <div className="col-sm-12">
                                <div className="input-group">
                                    <InputText placeholder="Busqueda..." name="textBusqueda" value={this.state.textBusqueda} onChange={this.handleInputChange}/>
                                    <span className="input-group-btn">
                                        <ButtonModal type="button" className="btn btn-primary btn-sm" onClick={() => this.props.onFilterData(this.state.textBusqueda.toString().toUpperCase())}>
                                            <i className="fa fa-search"></i>
                                        </ButtonModal>
                                    </span>
                                </div>
                            </div>
                        </Row>

                        <Row>
                            <ContainerCol className="col-sm-12">
                                <AgGridRender
                                    altura='353px'
                                    data={this.setData()}
                                    columnas={this.state.columnDefs}
                                    onGridReady={this.onGridReady}
                                    gridOptions={this.gridOptions}
                                />
                            </ContainerCol>
                        </Row>

                        <Row>
                            <div className="col-sm-12">
                                <PaginationLabels>
                                    {this.state.pagination.primeraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
                                </PaginationLabels>
                                <PaginationButtons>
                                    <div className="btn-group btn-group-xs" role="group">
                                        <button className="btn btn-default" onClick={() => this.gridBusquedaApi.paginationGoToFirstPage()}>
                                            <i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
                                        </button>
                                        <button className="btn btn-default" onClick={() => this.gridBusquedaApi.paginationGoToPreviousPage()}>
                                            <i className="fa fa-angle-left fa-fw"></i>Anterior
                                        </button>
                                        <button className="btn btn-default" onClick={() => this.gridBusquedaApi.paginationGoToNextPage()}>
                                            Siguiente<i className="fa fa-angle-right fa-fw"></i>
                                        </button>
                                        <button className="btn btn-default" onClick={() => this.gridBusquedaApi.paginationGoToLastPage()}>
                                            Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
                                        </button>
                                    </div>
                                </PaginationButtons>
                            </div>
                        </Row>

                        <Row>
                            <div className='col-sm-12'>
                                <div className="btn-group pull-right">
                                    <button type='button' className='btn btn-primary btn-sm' onClick={this.onSelect}><i className='fa fa-check fa-lg'></i> Seleccionar</button>                    
                                    <button type='button' className='btn btn-danger btn-sm' onClick={this.props.onClose}><i className='fa fa-times-circle fa-lg'></i> Cerrar</button>                                                
                                </div>
                            </div>
                        </Row>
                    </ModalContainer>
                </ModalResponsive>
            </div>
        );
    }
}

const mapStateToProps = ((state) => {
    return {
      cuentasContables_sel: state.contabilidad.cuentasContables_sel,
      indicadorCCosto: state.contabilidad.indicadorCCosto,
    };
});
  
export default connect (mapStateToProps)(BusquedaProveedor);